import React, { useContext, useEffect, useState, useRef, Fragment } from "react";
import { MdKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { FaEdit, FaHardHat, FaHistory } from "react-icons/fa";
import AppContext from "../../context/AppContext";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchFieldAgentMap, fetchPdfDataTaskList, fetchTasks, taskHistoryDetailsByDept, updateTaskPriority } from "../../service/Task";
import { MdOutlineSecurity } from "react-icons/md";
import { createPortal } from "react-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

import { Spinner } from "../../Spinner";
import translations from "../common/Translations";
import { getWorkflows } from "../../service/workflow";
import ReactSelector from "../common/CommonReactSelector";
import { IoSearch } from "react-icons/io5";
import FilterSelect from "../common/FilterSelect";
import Cookies from "js-cookie";
import calender from "../../assets/calendar.png"
import actionImage from "../../assets/actionImage.png"
import { GrPowerReset } from "react-icons/gr";
import fileTypeIcon from "../../assets/fileTypeIcon.png"
import { components } from 'react-select';
import moment from "moment";
import Modal from "../modals/Modal";
import { Dialog, Transition } from "@headlessui/react";
import { RxCross2 } from "react-icons/rx";
const Placeholder = (props) => {
  return <components.Placeholder {...props} />;
};
const TaskListView = ({
  isChecked,
  setIsChecked,
  selectedtask,
  setselectedtask,
  selectedfieldAgent,
  selectedFieldAgentId,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  setTotalPageSize,
  totalPageSize, setFinishedStatus
}) => {
  const navigate = useNavigate();
  // const [totalValue, setTotalValue] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef(null);
  const [hoveredTaskId, setHoveredTaskId] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [areainputValue, setAreaInputValue] = useState("");
  const [assignTaskAgent, setAssignTaskAgent] = useState("");
  const [selectedPriorityName, setselectedPriorityName] =
    useState("Select Priority");
  const [selectItemColor1, setSelectItemColor1] = useState("");
  const [selectItemColor, setSelectItemColor] = useState("");
  const [selectedStatusName, setselectedStatusName] = useState("Select Status");
  const [optionsTaskAgent, setOptionsTaskAgent] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState("Select Field Agent");
  const totalPagesCount = Math.ceil(totalPageSize / pageSize) ;
  const [open, setOpen] = useState(false);
  const [selectedPdfLink, setSelectedPdfLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [accountHistory, setAccountHistory] = useState(null);
  const priorityoptions = [
    { value: "Everything", label: "All"},
    { value: "Low_Priority", label: "Low Priority" },
    { value: "Medium_Priority", label: "Medium Priority" },
    { value: "High_Priority", label: "High Priority" },
  ];

  const activeoptions = [
    { value: "Everything", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Assigned", label: "Assigned" },
    { value: "In_Progress", label: "In Progress" },
    { value: "Completed", label: "Completed" },
    { value: "On_Hold", label: "On Hold" },
    { value: "Finished", label: "Finished" },
  ];

  const context = useContext(AppContext);
  const {
    workflowId,
    priority,
    active,
    setTaskData,
    taskData,
    setSelectAll,
    selectAll,
    areaCode,
    accountNo,
    selectedUserId,
    setAccountNo,
    selectedSubactivity,
    selectedOrgId,
    setActive,
    setPriority,
    langMode,
    userType,
    setAreaCode,
    setSelectedUserName,
    fieldAgentList,
    activityId,
    projectId
  } = context;

  const { theme } = useContext(AppContext);

  const previousPriority = useRef(priority);
  const previousPageSize = useRef(pageSize);

  // const parentRef = useRef(null);
  // const childRef = useRef(null);
  // const [parentHeight, setParentHeight] = useState(74); // Default height
  // const [isExtraAdded, setIsExtraAdded] = useState(false);

  // useEffect(() => {
  //   const updateHeight = () => {
  //     if (childRef.current) {
  //       const childHeight = childRef.current.scrollHeight;
  //       const newHeight = childHeight > 74 ? childHeight : 74;

  //       // Add 40px extra when content wraps
  //       if (window.innerWidth <= 1440 && !isExtraAdded) {
  //         setParentHeight(newHeight + 40);
  //         setIsExtraAdded(true);
  //       }
  //       // Remove extra 40px when content fits
  //       else if (window.innerWidth > 1440 && isExtraAdded) {
  //         setParentHeight(newHeight - 40);
  //         setIsExtraAdded(false);
  //       } else {
  //         setParentHeight(newHeight);
  //       }
  //     }
  //   };
  //   // Initial update
  //   updateHeight();

  //   // Update on window resize
  //   window.addEventListener('resize', updateHeight);

  //   // Cleanup
  //   return () => window.removeEventListener('resize', updateHeight);
  // }, []);


  const fetchData = async (
    workflowId,
    currentPage,
    pageSize,
    priority,
    active,
    areaCode,
    accountNo,
    selectedUserId,
    selectedSubactivity,
    fromDate,
    toDate
  ) => {
    if (!activityId) {
      setTaskData([]);
      setTotalPageSize(0);
      return;
    }
    try {
      setLoading(true);
      const data = await fetchTasks({
        workflowIds: activityId,
        currentPage :accountNo ? 0 : currentPage,
        pageSize,
        priority : typeof priority === 'number' ? 'Priority' : priority,
        active : active,
        areaCode : areaCode,
        accountNo : accountNo,
        selectedUserId : assignTaskAgent || selectedUserId,
        selectedSubactivity : selectedSubactivity,
        fromDate,
        toDate
      });
      setTaskData(data.taskList);
      setTotalPageSize(data.totalSize);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFieldAgentMap(activityId)
      .then((res) => {
        console.log('resresresresres', res.body);

        const agentOptions = res?.body.value?.map((agent) => ({
          value: agent.userId,
          label: agent.name || agent.email || "Unnamed Agent", // adjust based on available fields
        }));
        setOptionsTaskAgent(agentOptions);
      })
      .catch((err) => {
        console.error("Failed to fetch agents:", err);
      })
      .finally(() => {
      });
  }, [activityId]);


  useEffect(() => {
      fetchData(
        activityId,
        currentPage,
        pageSize,
        priority,
        active,
        areaCode,
        accountNo,
        selectedUserId  || assignTaskAgent,
        selectedSubactivity,
        fromDate,
        toDate
      );
    previousPriority.current = priority;
    previousPageSize.current = pageSize;
  }, [
    activityId,
    workflowId,
    currentPage,
    pageSize,
    priority,
    active,
    areaCode,
    accountNo,
    selectedUserId,
    assignTaskAgent,
    selectedSubactivity,
    fromDate,
    toDate
  ]);

  const totalPages = Math.ceil(totalPageSize / pageSize) - 1;
  const totalItems = totalPageSize;
  const startIndex = ((currentPage + 1) - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, totalItems);

  const handlePageSizeChange = (e) => {
    const size = parseInt(e?.value, 10);
    setPageSize(size);
    setCurrentPage(0);
    setSelectAll(false);
  };

  useEffect(() => {
    if ((selectedOrgId, workflowId)) {
      setTaskData([]);
      setCurrentPage(0);
      setPageSize((prev) => prev);
      // setActive('Active')
      // fetchData(selectedOrgId, workflowId, currentPage, active);
    }
  }, [selectedOrgId, workflowId, activityId]);

  useEffect(() => {
    if(projectId === null){
      localStorage.removeItem("activityId")
    }
  }, [projectId])


  window.onload = () => {
    Cookies.remove("mapListFilters");
    setselectedPriorityName("Select Priority");
    setPriority("Priority");
    setselectedStatusName("Select Status");
    setActive("Status");
    // setSelectedUserId("")
    setAreaCode("")
    setSelectedUserName(0)

    sessionStorage.removeItem("taskSearchValue")
    setAccountNo("");
    setInputValue("")

    sessionStorage.removeItem("from_Date")
    setFromDate("")

    sessionStorage.removeItem("to_Date")
    setToDate("")

  }

  const handleSearch = () => {
    setAccountNo(inputValue); // Set the final value on search
    sessionStorage.setItem("taskSearchValue", inputValue); // Save value in sessionStorage
  };

  useEffect(() => {
    const savedSearch = sessionStorage.getItem("taskSearchValue");
    if (savedSearch) {
      setAccountNo(savedSearch);
      setInputValue(savedSearch)
    }
  }, []);

  // useEffect(() => {
    // console.log("value ====> areainputValue",areainputValue)
  //   if (areainputValue?.length === 0) {
  //     // handleAreacodeSearch();
  //   }
  // }, [areainputValue]);
  useEffect(() => {
    if (inputValue?.length === 0) {
      handleSearch();
    }
  }, [inputValue]);

  useEffect(() => {
    const storedPriority = Cookies.get("mapListFilters");
    if (storedPriority) {
      const parsedPriority = JSON.parse(storedPriority);

      // setselectedPriorityName(parsedPriority?.selectedPriority);
      // setselectedStatusName(parsedPriority?.selectedStatus);
      // setAreaInputValue(parsedPriority?.areaInput)
      // setselectedPriorityName(parsedPriority?.selectedPriority ?? '');
      // setselectedStatusName(parsedPriority?.selectedStatus ?? '');
      setAreaInputValue(parsedPriority?.areaInput ?? '');

      if(Array.isArray(priorityoptions)){
        const selectedOption = priorityoptions.find(
          (option) => option.value === parsedPriority?.selectedPriority
        );
        if (selectedOption) {
          setSelectItemColor1(theme === "dark" ? "white" : "black");
        }
      }

      if(Array.isArray(fieldAgentList)){
        const selectedAgent = (fieldAgentList || [])?.find(
          (agent) => agent.userId === parsedPriority?.selectedUserId
        );
        if (selectedAgent) {
          setSelectedUserName(selectedAgent.name);
        }
      }
    }

  }, [priorityoptions, theme, fieldAgentList]);

  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleCheckboxChange = (index) => {
    const newData = [...taskData];
    newData[index].isChecked = !newData[index].isChecked;

    if (newData.some((task) => task.isChecked)) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }

    if (newData[index].isChecked) {
      setselectedtask([...selectedtask, newData[index].taskId]);
    } else {
      setselectedtask((prevValues) =>
        prevValues.filter((value) => value !== newData[index].taskId)
      );
    }
    setTaskData(newData);
  };

  const handleSelectAllChange = () => {
    const newData = taskData.map((task) => ({
      ...task,
      isChecked: !selectAll,
    }));
    if (!selectAll) {
      const allTaskIds = newData.map((task) => task.taskId);
      setselectedtask(allTaskIds);
      setIsChecked(true);
    } else {
      setselectedtask([]);
      setIsChecked(false);
    }
    setTaskData(newData);
    setSelectAll(!selectAll);
  };
  const updateTaskPriorityHandler = async (taskId, newPriority) => {
    try {
      const responseData = await updateTaskPriority(taskId, newPriority);
      if (responseData.header.code === 600) {
        const updatedTaskData = taskData.map((task) => {
          if (task.taskId === taskId) {
            return {
              ...task,
              priority: newPriority,
            };
          }
          return task;
        });
        setTaskData(updatedTaskData);
        setselectedtask(
          updatedTaskData
            .filter((task) => task.isChecked)
            .map((task) => task.taskId)
        );
        toast.success("Task Priority Updated");
      } else {
        console.error("Failed to update priority:", responseData.statusText);
      }
    } catch (error) {
      console.error("Error updating task priority:", error);
    }
  };

  const handleTaskClick = (taskId, accountNo) => {
    navigate(`/task-detail/${taskId}`);
    setAccountNo(accountNo);
  };

  // const baseHeaders = [
  //   translations[langMode].taskId,
  //   translations[langMode].accno,
  //   translations[langMode].Activity,
  //   translations[langMode].priority,
  //   translations[langMode].taskstatus,
  //   translations[langMode].source,
  //   translations[langMode].areCode,
  //   // "Office ",
  // ];

   const baseHeaders = [
    {value:"taskId", label:translations[langMode].taskId},
    {value:"Account No.", label:translations[langMode].accno},
    {value:"History", label:translations[langMode].History},
    {value:"Activity", label:translations[langMode].Activity},
    {value:"priority", label:translations[langMode].priority},
    {value:"taskStatus", label:translations[langMode].taskstatus},
    {value:"source", label:translations[langMode].source},
    {value:"Area Code", label:translations[langMode].areCode},
    // "Office ",
  ];
 
  // Extract the `value` fields from baseHeaders for comparison
const baseHeaderKeys = baseHeaders.map(header => header.value.trim());

const dynamicHeaders =
  taskData && taskData.length > 0
    ? Object.keys(JSON.parse(taskData[0].taskDetails)).filter(
        (key) => !baseHeaderKeys.includes(key.trim())
      ).map(key => ({
        value: key,
        label: key  // Or apply a dynamic label logic if needed
      }))
    : [];
  const tableHeaders = [...baseHeaders, ...dynamicHeaders];


  const handleEditTask = (taskId) => {
    navigate(`/update-complete-task/${taskId}`);
  };
  const handleMouseEnter = (taskId, e) => {
    // Use currentTarget instead of target to ensure the correct element
    const rect = e.currentTarget.getBoundingClientRect();

    setTooltipPosition({
      top: rect.top + window.scrollY + rect.height / 2, // Center the tooltip vertically
      left: rect.left + window.scrollX + rect.width + 10, // Position it to the right
    });
    setHoveredTaskId(taskId);
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false);
    setHoveredTaskId(null);
  };

  const Tooltip = ({ task }) => {
    // If no task is provided or the tooltip is not visible, return null
    if (!task || !tooltipVisible) return null;

    return createPortal(
      <div
        className="absolute w-[250px] overflow-y-auto h-auto z-50 px-4 py-3 text-sm font-medium text-white bg-gray-800 rounded-lg shadow-lg"
        style={tooltipPosition}
      >
        {task.assignees?.length > 0 ? (
          task.assignees.map((assignee) => (
            <div
              key={assignee.assigneeId}
              className="border-b border-gray-700 last:border-none py-2"
            >
              <div className="text-yellow-300">
                <strong>{translations[langMode].FieldId}:</strong> {assignee.assigneeId}
              </div>
              <div className="text-blue-300">
                <strong>{translations[langMode].FieldAgentName}:</strong> {assignee.assigneeName}
              </div>
            </div>
          ))
        ) : (
          <div>{translations[langMode].NoasssingData}</div>
        )}
      </div>,
      document.body
    );
  };

  const options = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
  ];


  const handleInputChange = async (event) => {

    setInputValue(event.target.value); // Update temporary state    

    // handleSearch()
    // setAccountNo(event.target.value)
  };


  const handleAccountNoSearch = () => { 

    setAccountNo(inputValue)
  }

  const handleSetMapListFilters = (key, value) => {
    if (!key) {
      console.error("Error: Key is required to set the filter.");
      return;
    }

    try {
      let mapListData = Cookies.get("mapListFilters");

      if (mapListData) {
        try {
          mapListData = JSON.parse(mapListData);
        } catch (parseError) {
          console.error("Invalid JSON in mapListFilters cookie:", parseError);
          mapListData = {}; // Reset if parsing fails
        }
      } else {
        mapListData = {};
      }

      // Ensure mapListData is an object
      if (typeof mapListData !== "object" || mapListData === null) {
        mapListData = {};
      }

      mapListData[key] = value;

      Cookies.set("mapListFilters", JSON.stringify(mapListData));
    } catch (error) {
      console.error("Error updating mapListFilters cookie:", error);
    }
  };


  const handleAreaCodeChange = (event) => {
    const value = event.target.value;
    setAreaInputValue(value);
    handleSetMapListFilters("areaInput", value);

    if(value.trim() === ""){
      setAreaCode(value);
    }
  };

  const handleAreacodeSearch = () => {
    setAreaCode(areainputValue);
  };

  const handleAssignTaskAgent = (event) => {
    // console.log('eventeventevent',event);
    setAssignTaskAgent(event.value);
    setSelectedAgent(event.value)
  };

  const handleAreaCodeSearch = () => {
    setAreaCode(areainputValue);
    handleSetMapListFilters("areaInput", areainputValue);
    setAreaInputValue("");
  }

  const handlePrioritySelection = (selectedValue) => {
    const selectedOption = priorityoptions.find(
      (option) => option.value === selectedValue?.value
    );
    console.log("selectedValue", selectedValue, "====", selectedOption)
    if (selectedOption) {
      setselectedPriorityName(selectedOption.value);
      setSelectItemColor1(theme === "dark" ? "white" : "black");
      setPriority(
        selectedOption.value === "Priority" ? "Default" : selectedOption.value
      );
      if (selectedOption && selectedOption.value) {
        handleSetMapListFilters("selectedPriority", selectedOption.value);
      } else {
        console.warn("selectedOption or selectedOption.id is undefined:", selectedOption);
      }

    }
  };

  const handleStatusSelection = (selectedValue) => {
    const selectedOption = activeoptions.find(
      (option) => option.value === selectedValue.value
    );
    if (selectedOption) {
      setselectedStatusName(selectedOption.value);
      setFinishedStatus(selectedOption.value);
      setSelectItemColor(theme === "dark" ? "white" : "black");
      setActive(selectedOption.value === "Status" ? "Default" : selectedOption.value);
      handleSetMapListFilters("selectedStatus", selectedOption.value)
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
  };

  const getPageNumbers = () => {
    const pages = [];
    if (totalPagesCount <= 7) {
      for (let i = 1; i <= totalPagesCount; i++) pages.push(i);
    } else {
      pages.push(1);
      if ((currentPage + 1) > 3) pages.push("...");
      let start = Math.max(2, (currentPage + 1) - 1);
      let end = Math.min(totalPagesCount - 1, (currentPage + 1) + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      if ((currentPage + 1) < totalPagesCount - 2) pages.push("...");
      pages.push(totalPagesCount);
    }
    return pages;
  };


  const handleReset = () => {
    // Reset dropdowns
    setselectedPriorityName("Select Priority");
    setPriority("Priority"); // Assuming you have a setPriority state
    handlePrioritySelection('Default')
    setselectedStatusName("Select Status");
    setActive("Status"); // Assuming you have a setActive state
    handleStatusSelection('Default')
    setSelectedUserName(""); // Assuming "" is the default
    // Reset text inputs
    setInputValue("");
    setPageSize(10)
    setAccountNo(""); // Assuming you have this state
    setAreaInputValue("");
    setAreaCode(""); // Assuming you have this state too
    setSelectedAgent("Select Field Agent")
    // Reset date inputs
    setFromDate("");
    setToDate("");
    setAssignTaskAgent("")
    // Reset hovered task
    setHoveredTaskId(null);
    // Remove from session storage
    sessionStorage.removeItem("taskSearchValue");
    sessionStorage.removeItem("from_Date");
    sessionStorage.removeItem("to_Date");
  };

  const handleOpenPDF = async (taskId) => {
    try {
      const data = await fetchPdfDataTaskList(taskId);
      
      if (data === null || data === undefined) {
        toast.error("PDF is not available");
        return;
      }
      setSelectedPdfLink(data);
      setOpen(true);

    } catch (error) {
      console.error("Error fetching PDF data:", error);
    }
  }

    const fetchTaskHistory = async (accountNumber) => {
      setIsLoading(true);
      try {

        const responseData = await taskHistoryDetailsByDept(
          accountNumber,
          projectId
        );

        if (responseData?.header?.code === 600) {
          setAccountHistory(responseData?.body?.value);
          toast.success("Data fetched successfully");
        } else {
          toast.error(responseData.body.value);
        }
      } catch (error) {
        console.error("Error fetching task history:", error);
        toast.error("An error occurred while fetching the task history");
      } finally {
        setIsLoading(false);
      }
    };

  return (
    <>
      <div
        className={` bg-white rounded-[10px] task-list-table sticky w-[93vw] ${theme === "dark"
          ? "dark-mode"
          : theme === "high-contrast"
            ? "high-contrast"
            : ""
          }`}
      >
        <div className={`py-4 pr-[15px] px-5 flex justify-between items-center border border-b-[#D1D5DB] w-full absolute overflow-x-auto`}
          // style={{
          //   // height: `${parentHeight}px`,
          //   // transition: 'height 0.3s ease', // Smooth transition
          // }}
          style={{
            zIndex: 10,  // Add z-index to parent to ensure visibility of dropdown
          }}
        >
          {/* <div className="px-5 flex justify-between items-center"> */}
            <div className="flex gap-4">
              <div className="flex flex-nowrap whitespace-nowrap flex-row gap-4 max-h-[40px] h-full">
                <div className="flex">
                  <div className="relative">
                    <input
                      id="account-search"
                      autoComplete="new-password"
                      type="text"
                      className={`block h-10 text-sm text-gray-900 border border-gray-300  ${langMode === 'ar' ? 'rounded-r-md' : 'rounded-l-md'} w-36
                                  focus:ring-blue-300 focus:border-blue-300  
                                    ${theme === "dark"
                          ? "dark-mode  "
                          : theme === "high-contrast"
                            ? "high-contrast  "
                            : ""
                        }`}
                      placeholder={translations[langMode].enteraccno}
                      value={inputValue}
                      onChange={handleInputChange}
                    />
                  </div>

                  <button
                    onClick={handleAccountNoSearch}
                    className={`h-10 px-4 bg-[#236DB4] text-white ${langMode === 'ar' ? 'rounded-l-md' : 'rounded-r-md'}`}
                  >
                    <IoSearch size={20} />{" "}
                  </button>
                </div>

                <div className="flex">
                  <div className="relative">
                    <input
                      id="account-search"
                      autoComplete="new-password"
                      type="text"
                      className={`block h-10 text-sm text-gray-900 border border-gray-300  ${langMode === 'ar' ? 'rounded-r-md' : 'rounded-l-md'} w-36
                                  focus:ring-blue-300 focus:border-blue-300  
                                    ${theme === "dark"
                          ? "dark-mode  "
                          : theme === "high-contrast"
                            ? "high-contrast  "
                            : ""
                        }`}
                      placeholder={translations[langMode].searchbycode}
                      value={areainputValue}
                      onChange={handleAreaCodeChange}
                    />
                  </div>

                  <button
                    onClick={handleAreacodeSearch}
                    className={`h-10 px-4 bg-[#236DB4] text-white ${langMode === 'ar' ? 'rounded-l-md' : 'rounded-r-md'}`}
                  >
                    <IoSearch size={20} />{" "}
                  </button>
                </div>
                <div className="w-[115px]">
                <ReactSelector
                value={priorityoptions.find(option => option.value === selectedPriorityName) || null}
                  options={priorityoptions}
                  onChange={handlePrioritySelection}
                  height="40px !important"
                  menuPlacement="bottom"
                  menuPortalTarget={document.body}
                    components={Placeholder}
                    placeholder={translations[langMode].priority}
                    fontSize="14px"

                  />
                </div>
                <div className="w-[100px]">
                <ReactSelector
                  value={activeoptions?.find(item => item.value === selectedStatusName)|| null}
                  options={activeoptions}
                  onChange={handleStatusSelection}
                  height="40px !important"
                  menuPlacement="bottom"
                  menuPortalTarget={document.body}
                    components={Placeholder}
                    placeholder={translations[langMode].status}
                    fontSize="14px"
                  />
                </div>
                <div className="w-[153px]">
                  <ReactSelector
                    value={
                      [{ value: "", label: "All" },...(optionsTaskAgent || [])]?.find(item => item.value === selectedAgent) || null
                    }
                    options={optionsTaskAgent && [{ value: "", label: "All" },...(optionsTaskAgent || [])]}
                    // isLoading={loading}

                    isSearchable={true}

                    height="40px !important"
                    menuPlacement="bottom"
                    menuPortalTarget={document.body}
                    components={{ Placeholder }}

                    placeholder={translations[langMode].fieldAgent}
                    onChange={handleAssignTaskAgent}
                    position="fixed"

                  />
                </div>

                {/* <FilterSelect
                  defaultText={translations[langMode].status}
                  options={activeoptions}
                  onChange={handleStatusSelection}
                  value={selectedStatusName}
                  selectItemColor={selectItemColor}
                  listBoxClass={"!mt-0"}
                  classname={"h-full"}
                /> */}

                {/* <FilterSelect
                  defaultText={"Field Agent"}
                  classname={"h-full"}
                  listBoxClass={"!mt-0"}
                  options={["super_admin", "Admin", "office_user", "field_agent"]?.map((item) => ({ "value": item, "label": item }))}
                /> */}

                <div className="w-[153px]">
                  <div className="flex items-center relative">
                    <input
                      type="text"
                      className={`text-sm form-input rounded-[8px] w-full h-[40px] border border-[#00000066] shadow-[0_0_0_1px_#D1D5DB] relative  ${theme === "dark"
                        ? "dark-mode border-gray-200 placeholder-white"
                        : theme === "high-contrast"
                          ? "high-contrast"
                          : ""
                        }`}
                      value={fromDate ? formatDate(fromDate) : ""}
                      onFocus={(e) => (e.target.type = "date")}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          e.target.type = "text";
                        }
                      }}
                      onChange={(e) => {
                        setFromDate(e.target.value);
                        sessionStorage.setItem("from_Date", e.target.value)
                      }}
                      placeholder={translations[langMode].fromdate}
                    />
                    {/* <img src={calender} className="absolute right-[7px]" /> */}
                  </div>
                </div>

                <div className="w-[153px]">
                  <div className="flex items-center relative">
                    <input
                      type="text"
                      className={`text-sm form-input border border-[#00000066] shadow-[0_0_0_1px_#D1D5DB] rounded-[8px] w-full h-[40px] relative ${theme === "dark"
                        ? "dark-mode border-gray-200 placeholder-white"
                        : theme === "high-contrast"
                          ? "high-contrast"
                          : ""
                        }`}
                      value={toDate ? formatDate(toDate) : ""}
                      onFocus={(e) => (e.target.type = "date")}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          e.target.type = "text";
                        }
                      }}
                      onChange={(e) => {
                        setToDate(e.target.value);
                        sessionStorage.setItem("to_Date", e.target.value)
                      }}
                      placeholder={translations[langMode].todate}
                    />
                    {/* <img src={calender} className="absolute right-[7px]" /> */}
                  </div>
                </div>

                <div className="flex items-center">
                  <button onClick={handleReset} className="border border-gray-300 rounded-lg" ><GrPowerReset size={20} className="m-1" />
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div className="text-sm text-gray-400 flex items-center gap-3 pl-[24px]">
                <label htmlFor="pageSize">{translations[langMode].rows}</label>
                <div className="w-[83px]">
                  <ReactSelector
                    value={options?.find(item => item.value == pageSize)}
                    options={options}
                    onChange={handlePageSizeChange}
                    height="40px !important"
                    // defaultMenuIsOpen={true}
                    menuPlacement="bottom"
                    menuPortalTarget={document.body}
                  />
                </div>
              </div>
            </div>
          {/* </div> */}
        </div>
        <div className={`sm:rounded-lg overflow-auto relative py-[24px] w-full`} style={{ top: `74px`, height: "calc(100% - 159px)" }}>
          <table className="w-full text-xs text-left rtl:text-right text-gray-500 dark:text-gray-400 overflow-y-auto relative z-0">
            <thead className="text-xs text-gray-700 border-b border-[#E9E9E9] dark:text-gray-400">
              <tr
                className={`bg-[#F5F6FA] ${theme === "dark"
                  ? "dark-mode"
                  : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                  }`}
              >
                <th className="text-xs font-medium uppercase tracking-wider text py-[15px] pl-[24px] flex gap-[10px] items-center text-[#111827]">
                  <input
                    type="checkbox"
                    className={`w-4 h-4 text-blue-800 bg-gray-100 border-gray-300 rounded focus:ring-blue-800 dark:focus:ring-blue-800 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:border-gray-600 ${theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                      }`}
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                  />
                  <label>{translations[langMode].number}</label>
                </th>
                <th className="text-xs font-medium capitalize tracking-wider text py-[15px] pl-[24px] text-[#111827]">
                  {translations[langMode].Action}
                </th>
                {/* <th scope="col" className="px-2 py-3">
                  <input
                    type="checkbox"
                    className={`w-4 h-4 text-blue-800 bg-gray-100 border-gray-300 rounded focus:ring-blue-800 dark:focus:ring-blue-800 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:border-gray-600 ${theme === "dark"
                        ? "dark-mode"
                        : theme === "high-contrast"
                          ? "high-contrast"
                          : ""
                      }`}
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                  />
                </th> */}
                {/* <th
                  scope="col"
                  className={`px-6 py-2 text-xs font-medium capitalize tracking-wider text-nowrap py-[15px] pl-[24px] text-[#111827]`}
                >
                  PDFs
                </th> */}
                {tableHeaders.map((header, index) => (
                  <th
                    key={index}
                    scope="col"
                    className={`px-6 py-2 text-xs font-medium capitalize tracking-wider text-nowrap py-[15px] pl-[24px] text-[#111827] ${index === 0 ? 'text-center' : 'text-left'}`}
                  >
                    {header?.label}
                  </th>
                ))}

                <th
                  scope="col"
                  className={`px-6 py-2 text-xs font-medium capitalize tracking-wider text-nowrap py-[15px] pl-[24px] text-[#111827]`}
                >
                  {translations[langMode].comapletedDate}
                </th>
              </tr>
            </thead>
            <tbody className="overflow-scroll">
              {loading && <Spinner />}
              {
                !activityId ?
                  <tr>
                    <td colSpan={tableHeaders.length + 4} className="text-gray-700 font-normal text-center text-base py-4">
                      Selected WorkFlow Id
                    </td>
                  </tr>
                  :
                  (taskData || [])?.length <= 0 ? (
                    <tr>
                      <td colSpan={tableHeaders.length + 4} className="text-gray-700 font-normal text-center text-base py-4">
                        {translations[langMode].noDatavb}
                      </td>
                    </tr>
              ) :
               (
                (taskData || [])?.map((task, index) => {
                  const taskDetailsObj = JSON.parse(task.taskDetails);
                  return (
                    <tr
                      key={index}
                      className={`bg-white text-xs border-b border-[#E9E9E9]  ${theme === "dark"
                          ? "dark-mode"
                          : theme === "high-contrast"
                            ? "high-contrast"
                            : ""
                        }`}
                    >
                      <td className="w-2 p-2 pt-[22px] pl-[24px] text-xs font-medium flex gap-[10px] items-center text-[#4B5563]">
                      <input
                    type="checkbox"
                    className={`w-4 h-4 text-blue-800 bg-gray-100 border-gray-300 rounded focus:ring-blue-800 dark:focus:ring-blue-800 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:border-gray-600 ${theme === "dark"
                        ? "dark-mode"
                        : theme === "high-contrast"
                          ? "high-contrast"
                          : ""
                      } ${task?.taskStatus === "Finished" ? "invisible" : ""}`}
                      checked={task.isChecked || false}
                    onChange={() => handleCheckboxChange(index)}
                  />
                    {((currentPage + 1) - 1) * pageSize + index + 1}
                  </td>

                            {task?.taskStatus === "Completed" ? <td className="w-2 p-2">
                              <button
                                className="ml-[19px]"
                                onClick={() => handleEditTask(task.taskId)}
                              >
                                <img src={actionImage} />
                              </button>
                            </td> : <td></td>}
                            {/* {task.taskStatus === "Completed" ? ( */}

                            {/* ) : (
                        <div className="w-6"></div>
                      )} */}
                            {/* <div className="flex items-center">
                          {!task.protected && (
                            <>
                              <input
                                id={`checkbox-table-search-${index}`}
                                type="checkbox"
                                className={`w-4 h-4 text-blue-800 bg-gray-100 border-gray-300 rounded focus:ring-blue-800
                               dark:focus:ring-blue-800 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2
                                 ${theme === "dark"
                                    ? "dark-mode  "
                                    : theme === "high-contrast"
                                      ? "high-contrast  "
                                      : ""
                                  }`}
                                checked={task.isChecked || false}
                                onChange={() => handleCheckboxChange(index)}
                              />
                              <label
                                htmlFor={`checkbox-table-search-${index}`}
                                className="sr-only"
                              >
                                checkbox
                              </label>
                            </>
                          )}
                        </div> */}
                            {/* </td> */}
                            {/* {
                              task?.taskStatus === "Completed" ?
                                <td
                                  scope="col"
                                  className={`px-6 py-2 text-xs font-medium capitalize tracking-wider text-nowrap py-[15px] pl-[24px] text-[#111827]`}
                                >
                                  <img src={fileTypeIcon} />
                                </td> : <td></td>
                            } */}
                            {tableHeaders.map((header, index) => (
                              <td
                                key={index}
                                className="px-7 py-2 text-nowrap relative text-xs font-normal"
                              >
                                {header?.value === "Account No." ? (
                                  <div className="flex text-xs font-normal">
                                    {task.protected && (
                                      <MdOutlineSecurity className="mr-2 text-blue-800" />
                                    )}
                                    {task.accountNo}
                                    {task?.taskStatus === "Completed" && (
                                      <img src={fileTypeIcon} className="ml-1 w-5 h-5 cursor-pointer pb-[3px]" onClick={() => handleOpenPDF(task.taskId)}/>
                                    )}
                                  </div>
                                ) : header?.value === "History" ? (
                                  <button onClick={() => fetchTaskHistory(task.accountNo)}>
                                    <FaHistory className="text-[#236DB4]" size={18} />
                                  </button>
                                )
                                  : header?.value === "taskId" ? (
                                    <div className="flex">
                                      <span
                                        className={`flex gap-2 
                                 cursor-pointer  bg-opacity-30 px-4 py-1 ${theme === "dark"
                                            ? "text-white"
                                            : theme === "high-contrast"
                                              ? "high-contrast"
                                              : ""
                                          }`}
                                        onClick={() =>
                                          handleTaskClick(task.taskId, task.accountNo)
                                        }
                                      >
                                        <div
                                          className="relative group "
                                          onMouseEnter={(e) => handleMouseEnter(task.taskId, e)}
                                          onMouseLeave={handleMouseLeave}
                                        >
                                          <span className="pt-2 " ref={tooltipRef}>
                                            {task.taskStatus === "Assigned" && (
                                              <FaHardHat className="text-yellow-400 m-1" />
                                            )}
                                            {task.taskStatus === "Completed" && (
                                              <FaHardHat className="text-green-500 m-1" />
                                            )}
                                            {task.taskStatus === "On_Hold" && (
                                              <FaHardHat className="text-red-500 m-1" />
                                            )}
                                            {task.taskStatus === "In_Progress" && (
                                              <FaHardHat className="text-orange-500 m-1" />
                                            )}
                                          </span>

                                        </div>
                                        {task.taskId}
                                      </span>
                                      {hoveredTaskId === task.taskId && <Tooltip task={task} />}

                                    </div>
                                  )
                                    : header?.value === "taskStatus" ? (
                                      <span
                                        className={`text-xs ${task.taskStatus === "Active"
                                          ? `px-4 py-1 font-medium text-xs rounded-[4px] border border-[#236DB4] text-[#236DB4] bg-[#236DB426] ${theme === "dark"
                                            ? "bg-opacity-80 text-[#236DB4]"
                                            : "bg-opacity-30"
                                          }`
                                          : ""
                                          } ${task.taskStatus === "Assigned"
                                            ? `px-4 py-1 font-medium text-xs rounded-[4px] border border-[#236DB4] text-[#236DB4] bg-[#236DB426] ${theme === "dark"
                                              ? "bg-opacity-40 text-yellow-400"
                                              : "bg-opacity-30"
                                            }`
                                            : ""
                                          } ${task.taskStatus === "On_Hold"
                                            ? `px-4 py-1 font-medium text-xs rounded-[4px] border border-[#EF4A00] text-[#EF4A00] bg-[#EF4A0033] ${theme === "dark"
                                              ? "bg-opacity-30 text-opacity-80"
                                              : "bg-opacity-30"
                                            }`
                                            : ""
                                          } ${task.taskStatus === "Completed"
                                            ? `px-4 py-1 font-medium text-xs rounded-[4px] border border-[#45B369] text-[#45B369] bg-[#45B36933] ${theme === "dark"
                                              ? "bg-opacity-30 text-green-400"
                                              : "bg-opacity-30"
                                            }`
                                            : ""
                                          } ${task.taskStatus === "In_Progress"
                                            ? `px-4 py-1 font-medium text-xs rounded-[4px] border border-[#FF9F29] text-[#FF9F29] bg-[#FF9F2933] ${theme === "dark"
                                              ? "bg-opacity-30 text-opacity-80"
                                              : "bg-opacity-30"
                                            }`
                                            : ""
                                          } ${task.taskStatus === "Finished"
                                            ? `px-4 py-1 font-medium text-xs rounded-[4px] border border-[#0e8635] text-[#0e8635] bg-[#45B36933] ${theme === "dark"
                                              ? "bg-opacity-30 text-opacity-80"
                                              : "bg-opacity-30"
                                            }`
                                            : ""
                                          } text-sm`}
                                      >
                                        {task.taskStatus.replace("_", " ")}
                                      </span>
                                    )
                                      : header?.value === "priority" ? (
                                        <select
                                          value={task.priority}
                                          onChange={(e) => {
                                            const newPriority = e.target.value;
                                            updateTaskPriorityHandler(
                                              task.taskId,
                                              newPriority
                                            );
                                          }}
                                          className={`py-1 px-2 text-xs border border-[#00000066] rounded-md ${theme === "dark"
                                            ? "dark-mode"
                                            : theme === "high-contrast"
                                              ? "high-contrast"
                                              : ""
                                            }`}
                                        >
                                          <option value="Low_Priority">Low</option>
                                          <option value="Medium_Priority">Medium</option>
                                          <option value="High_Priority">High</option>
                                        </select>
                                      ) : header?.value === "source" ? (
                                        // Custom rendering for the source field
                                        <span
                                          className={`px-2 py-1 text- border border-[#9A5DFC] rounded-[4px] 
                              bg-[#9A5DFC26] text-[#9A5DFC]
                              `}
                                        >
                                          {task.source}
                                        </span>
                                      ) : (
                                        taskDetailsObj[header?.value]
                                      )}
                              </td>
                            ))}
                            <td scope="col"
                              className={`p-2 pt-[22px] pl-[24px] text-xs flex gap-[10px] items-center text-[#4B5563]`}>
                              {task?.taskStatus === "Completed" ? moment(task?.finishedDate).format("DD-MM-YYYY") : "-"}
                            </td>
                          </tr>
                        );
                      })
                    )}

            </tbody>
          </table>
        </div>
        {/* {!taskData.length <= 0 && <div className="px-[15px] py-[15px] flex justify-between w-full bottom-0 absolute ">
          <div className="text-[#4B5563] text-xs font-normal">
          Showing {startIndex + 1} to {endIndex} of {totalItems} entries
          </div>
          <div className="flex items-center space-x-2">
            <button className="cursor- disabled:opacity-50" onClick={() => setCurrentPage(currentPage - 1)} disabled={(currentPage + 1) === 1}>
              <MdKeyboardDoubleArrowLeft size={20} />
            </button>
            {getPageNumbers().map((page, index) => (
              <button
                key={index}
                className={`px-3 py-1 border rounded-[4px] text-xs ${page === (currentPage + 1) ? "bg-[#236DB4] text-[#FFFFFF]" : "bg-[#EBECEF] text-[#4B5563]"
                  }`}
                onClick={() => page !== "..." && setCurrentPage(page - 1)}
                disabled={page === "..."}
              >
                {page}
              </button>
            ))}
            <button className="cursor-pointer disabled:opacity-50" onClick={() => setCurrentPage(currentPage + 1)} disabled={(currentPage + 1) === totalPagesCount}>
              <MdOutlineKeyboardDoubleArrowRight size={20} />
            </button>
          </div>
        </div>} */}
         {!taskData.length <= 0 && (
          <div className="mt-2">
            <p className="text-sm text-gray-400 flex items-center gap-4 px-[15px] py-[15px] w-full bottom-0 absolute ">
              {`${startIndex + 1}-${Math.min(endIndex, totalItems)} of ${totalItems} ${translations[langMode].items}`}
              <IoIosArrowBack
                onClick={goToPreviousPage}
                disabled={currentPage === 0}
                className={`cursor-pointer ${currentPage === 0 ? 'opacity-50' : ''}`}
              />
              <IoIosArrowForward
                onClick={goToNextPage}
                disabled={currentPage === totalPagesCount}
                className={`cursor-pointer ${currentPage === totalPagesCount ? 'opacity-50' : ''}`}
              />
            </p>
          </div>
        )}
        {open && (
          <Modal pdfLink={selectedPdfLink} setOpen={setOpen} open={open} />
        )}
        {(accountHistory !== null || isLoading) && 
          <div className="bg-white backdrop-blur-sm shadow-sm p-3">
                <Transition.Root show={true} as={Fragment}>
                  <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={() => setAccountHistory(null)}
                  >
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>
                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                          enterTo="opacity-100 translate-y-0 sm:scale-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                      <Dialog.Panel className={`relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-10 sm:max-w-l`}>
                        {isLoading ? (
                          <div className="flex justify-center gap-2 w-full px-2 items-center h-[300px]">
                            <p className="ml-4 text-sm text-gray-600">Fetching account details...</p>
                          </div>
                        ) : <>
                          <div className="justify-between items-center flex m-5 font-bold text-base">
                            <label className="">Account History</label>
                            <span className="cursor-pointer"
                              onClick={() => setAccountHistory(null)}
                            >
                              <RxCross2 />
                            </span>
                          </div>
                          <div className="w-full flex flex-col px-3 gap-5 h-auto my-2 overflow-y-auto">
                                <h3 className="mb-2 font-bold text-lg text-gray-800">Account Details</h3>
                                <div className="overflow-x-auto">
                              <div className="max-w-md w-full h-20">
                                <table className="whitespace-nowrap border border-gray-200 w-full account-history">
                                  <thead>
                                    <tr className="border border-gray-200 text-sm">
                                      {Object.entries(accountHistory?.accountDetails?.accountDetailsJson || {}).map(([key, value]) => (
                                        <th className="px-6 py-2 font-semibold">{key.trim()}</th>
                                      ))}
                                      <th className="px-6 py-2 font-semibold ">Current Outstanding</th>
                                      <th className="px-6 py-2 font-semibold">Last Updated Date</th>
                                      <th className="px-6 py-2 font-semibold">Last Updated Time</th>
                                      <th className="px-6 py-2 font-semibold">Current OS</th>
                                      <th className="px-6 py-2 font-semibold">OS Updated At</th>
                                    </tr>

                                  </thead>
                                  <tbody className="text-sm text-gray-700">
                                    <tr className="border border-gray-200 text-sm">
                                      {Object.entries(accountHistory?.accountDetails?.accountDetailsJson || {}).map(([key, value]) => (
                                        <td className="px-6 py-2">{value}</td>
                                      ))}
                                      <td className="px-6 py-2">{accountHistory?.accountDetails?.currentOutstanding || "-"}</td>
                                      <td className="px-6 py-2">{accountHistory?.accountDetails?.lastUpdatedDate || "-"}</td>
                                      <td className="px-6 py-2">{accountHistory?.accountDetails?.lastUpdatedTime || "-"}</td>
                                      <td className="px-6 py-2">{accountHistory?.accountDetails?.currentOs || "-"}</td>
                                      <td className="px-6 py-2">{accountHistory?.accountDetails?.currentOsUpdatedAt && moment.utc(accountHistory?.accountDetails?.currentOsUpdatedAt).format("DD-MM-YYYY HH:mm") || "-"}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                                </div>
                              <div className="max-w-md w-full flex flex-col gap-y-2">
                                <h3 className="font-bold text-gray-800 text-lg">Account History</h3>
                                {accountHistory?.accountHistory.map((workflow, index) => (
                                  <div key={index} className="flex flex-col gap-y-3 overflow-x-auto">
                                    <h3 className="mt-3 text-center font-medium text-gray-600">{workflow.workflowName}</h3>
                                    <table className="whitespace-nowrap border border-gray-200 w-full account-history">
                                      <thead>
                                        <tr className="border border-gray-200 text-sm">
                                          <th className="px-6 py-2 font-semibold">Task ID</th>
                                          <th className="px-6 py-2">Assignee</th>
                                          <th className="px-6 py-2">Finished Date</th>
                                          <th className="px-6 py-2">Finished Time</th>
                                          <th className="px-6 py-2">Workflow ID</th>
                                          <th className="px-6 py-2">PDF Link</th>
                                          <th className="px-6 py-2">Created By</th>
                                          <th className="px-6 py-2">Remarks</th>
                                        </tr>
                                      </thead>
                                      <tbody className="text-sm text-gray-700">
                                        {workflow.accountHistoryList.map((entry, idx) => (
                                          <tr key={idx} className="border border-gray-200">
                                            <td className="px-6 py-2">{entry.taskId}</td>
                                            <td className="px-6 py-2">{entry.assigneeName}</td>
                                            <td className="px-6 py-2">{entry.finishedDate}</td>
                                            <td className="px-6 py-2">{entry.finishedTime}</td>
                                            <td className="px-6 py-2">{entry.workflowId}</td>
                                            <td className="px-6 py-2">
                                              <a href={entry.pdfLink} target="_blank" rel="noopener noreferrer">
                                                View PDF
                                              </a>
                                            </td>
                                            <td className="px-6 py-2">{entry.createdBy || "-"}</td>
                                            <td className="px-6 py-2">{entry.remarks || "-"}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                ))}
                              </div>

                          </div>
                        </>
                        }
                      </Dialog.Panel>
                        </Transition.Child>
                      </div>
                    </div>
                  </Dialog>
                </Transition.Root>
          </div>
        }
      </div>
    </>
  );
};

export default TaskListView;
